/**
 * Get current viewer's country legal age
 * @param  {Object} countryGroups   List of country groups containing arrays of country codes
 * @return {Array}                 The viewer's country legal age informations
 */

import { getCountryGroup } from './country-group'

export async function getCountryLegalAge(countryGroups, customRatingsData) {
  if (!countryGroups || countryGroups === null) {
    return ''
  }

  let countryAgeData = []
  return (
    // Find current viewer's country group
    getCountryGroup(countryGroups)
      .then(currentGroup => {
        const currentGroupCode = currentGroup.groupCode

        if (customRatingsData && customRatingsData.ratings !== null) {
          // Get the project's custom data
          let customData = null
          customRatingsData.ratings.map((customGroup, i) => {
            if (customGroup.rating) {
              const rating = customGroup.rating.split('-') // Ratings values are formated as "groupCode-rating" (ex.: "esrb-mature", "pegi-16", etc.)
              const groupCode = rating[0]
              if (groupCode === currentGroupCode) {
                customData = { ...customGroup, groupCode }
              }
            }
          })
          // Find current viewer's country data
          countryGroups.map((group) => {
            let groupCode = group.groupCode
            if (groupCode === currentGroupCode) {
              const ratingData = group.ratings[0][customData.rating]
              let legalAge = parseInt(ratingData.legalAge)
              let enabledAgeGate = customData?.enabledAgeGate ? customData.enabledAgeGate : group.enabledAgeGate
              let lockAgeGate = customData?.lockAgeGate ? customData.lockAgeGate : group.lockAgeGate
              let enabledFullPageGate = customData?.enabledFullPageGate ? customData.enabledFullPageGate : group.enabledFullPageGate
              countryAgeData.push(legalAge, enabledAgeGate, lockAgeGate, enabledFullPageGate)
            }
          })
        }
      }).then(() => {
        // Return the legal age and the age gate state
        return countryAgeData
      }).catch(error => {
        return error
      })
  )
}
